import { useContext, useEffect } from 'react';

import permissions from 'common/permissions';
import strings from 'common/strings';
import { usePermissions, useVendor } from 'hooks';
import { VehicleCardTabType } from 'models';

import { VehicleCardContext } from '../../VehicleCard';
import VendorTasks from '../../VehicleCardVendorDesktop/VendorTasks';
import VehicleCardNotes from '../VehicleCardNotes';
import VehicleCardEngageDetails from './VehicleCardEngageDetails';
import VehicleCardInventoryDetails from './VehicleCardInventoryDetails';
import VehicleCardReconDetails from './VehicleCardReconDetails';

import './VehicleCardReconInventoryTabs.scss';

interface VehicleCardReconInventoryTabsProps {
  showNotesTab?: boolean;
}
var VehicleCardReconInventoryTabs = ({
  showNotesTab = false,
}: VehicleCardReconInventoryTabsProps) => {
  const {
    inExtensionCardMode,
    position,
    forceShowEngageTab,
    setCurrentTab,
    currentTab,
    vehicle,
  } = useContext(VehicleCardContext);
  const { isVendor } = useVendor();
  const onClick = (activeCollectionType: VehicleCardTabType) => {
    if (setCurrentTab !== undefined) {
      setCurrentTab(activeCollectionType);
    }
  };

  const { hasPermission } = usePermissions();

  useEffect(() => {
    if (!showNotesTab && currentTab === 'notes') {
      const tab =
        (hasPermission(permissions.RECON_VIEW) && 'recon') ||
        (hasPermission(permissions.INVENTORY_VIEW) && 'inventory') ||
        (hasPermission(permissions.PLUGIN_VELOCITYENGAGE_VIEW) && 'engage');

      setCurrentTab?.(tab);
    }
  }, [currentTab, hasPermission, setCurrentTab, showNotesTab]);

  const tabClass = showNotesTab
    ? 'VehicleCard-recon-inventory-tabs-no-notes'
    : '';

  return (
    <div className={`VehicleCard-recon-inventory-tabs ${tabClass}`}>
      <div
        className="VehicleCard-recon-inventory-tabs-container"
        data-vas-testing={`VehicleCard-tabs-container-${position.toString()}`}
      >
        {!isVendor && hasPermission(permissions.RECON_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3  ${
              currentTab === 'recon' ? 'active' : ''
            }`}
            onClick={() => onClick('recon')}
          >
            {strings.RECON}
          </div>
        )}
        {!isVendor && hasPermission(permissions.INVENTORY_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'inventory' ? 'active' : ''
            }`}
            onClick={() => onClick('inventory')}
          >
            {strings.INVENTORY}
          </div>
        )}
        {!isVendor && hasPermission(permissions.PLUGIN_VELOCITYENGAGE_VIEW) && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'engage' ? 'active' : ''
            }`}
            onClick={() => onClick('engage')}
          >
            {strings.ENGAGE}
          </div>
        )}
        {isVendor && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'tasks' ? 'active' : ''
            }`}
            onClick={() => onClick('tasks')}
          >
            {strings.TASKS}
          </div>
        )}
        {showNotesTab && (
          <div
            role="none"
            className={`VehicleCard-recon-inventory-tab-label mr-3 ${
              currentTab === 'notes' ? 'active' : ''
            }`}
            onClick={() => onClick('notes')}
          >
            {strings.NOTES}
          </div>
        )}
      </div>
      <div className="VehicleCard-recon-inventory-tab-content">
        {currentTab === 'recon' && <VehicleCardReconDetails />}
        {currentTab === 'inventory' && <VehicleCardInventoryDetails />}
        {currentTab === 'engage' &&
          (forceShowEngageTab || inExtensionCardMode) && (
            <VehicleCardEngageDetails />
          )}
        {currentTab === 'tasks' && <VendorTasks vehicle={vehicle!} />}
        {currentTab === 'notes' && (
          <VehicleCardNotes
            vehicleId={vehicle?.vehicleCard?.id!}
            notes={vehicle?.notesByDate!}
            isInTab={showNotesTab}
          />
        )}
      </div>
    </div>
  );
};

export default VehicleCardReconInventoryTabs;
